export const WebAppVersion = "5.4.0";
